import { useReactiveVar } from '@apollo/client';
import { useLocation } from '@hulu/react-router-dom';
import { useContext } from 'react';

import { RoutePath, userAmsUserIdVar } from '../../constants';
import { localStorageGhostModeName } from '../../constants/ghostMode';
import { GhostModeContext } from '../../context/GhostMode/GhostMode';
import { User } from '../../utils/user';

const useDoesUserIdMatchEntityId = (entityId?: string): boolean => {
  const { isGhostMode } = useContext(GhostModeContext);
  const ghostModeData = isGhostMode ? localStorage.getItem(localStorageGhostModeName) : undefined;
  const ghostData = ghostModeData ? JSON.parse(ghostModeData) : undefined;
  const { pathname } = useLocation();
  const regularUserId = useReactiveVar(userAmsUserIdVar);
  const adminUserId = User.getUserInfo().userInfo?.ams_user_id as string;

  const loggedInUserId = (pathname.includes(`${RoutePath.ADMIN}`) ? adminUserId : regularUserId) || '';

  // Have to check 3 places for logged in user id: ghost mode, admin, regular user
  const userId = isGhostMode && ghostData ? ghostData.userId || '' : loggedInUserId;
  return userId.length > 0 && userId === entityId;
};

export default useDoesUserIdMatchEntityId;
